export default __webpack_public_path__ + "static/personajeTerms-739be0804fba5639566e691721cccc66.svg";